import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const ConfirmBox = ({ title, message, onConfirm, onCancel, children }) => {
  const handleClick = () => {
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: "Yes",
          onClick: onConfirm,
        },
        {
          label: "No",
          onClick: onCancel,
        },
      ],
    });
  };

  return <div onClick={handleClick}>{children}</div>;
};

export default ConfirmBox;
